import { SelectInputV2 } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { LuTriangleAlert } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useSelectCostCenter } from './select-cost-center.controller';

const ID = 'select-cost-center';

export const SelectCostCenter = () => {
    const viewProps = useSelectCostCenter();

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.handleSubmit,
                submitLabel: CommonMessage.BUTTONS.CONTINUE,
                submitDisabled: viewProps.submitDisabled
            }}
            header={{ onBack: viewProps.onBack }}>
            <div className='flex w-full flex-col gap-6'>
                <div className='flex flex-col gap-2'>
                    <p className='text-foreground-default text-lg font-semibold'>
                        <FormattedMessage
                            id='kiosk.wizard.select-cost-center.title'
                            defaultMessage='Select cost center'
                            description='Title shown on the cost center selection screen'
                        />
                    </p>
                </div>

                {viewProps.isCostCenterEnabled && (viewProps.userCostCenters.length > 0 || viewProps.isCostCenterLoading) && (
                    <SelectInputV2
                        hideLabel
                        isLoading={viewProps.isCostCenterLoading}
                        label={CommonMessage.OBJECTS.COST_CENTER.DEFAULT}
                        onScrollToBottom={viewProps.onCostCenterScrollToBottom}
                        onSearch={viewProps.onCostCenterSearch}
                        options={viewProps.userCostCenters.map((costCenter) => ({ label: costCenter.name, value: costCenter.id }))}
                        value={viewProps.selectedUserCostCenter}
                        onSelect={(value) => viewProps.onCostCenterSelect(value ? value.value : null)}
                    />
                )}

                {viewProps.hasNoCostCenters && (
                    <div className='bg-status-warning/20 border-status-warning flex w-full flex-col items-center gap-2 rounded-xl border p-4'>
                        <div className='flex w-full items-center gap-3'>
                            <LuTriangleAlert className='text-foreground-default size-10' />
                            <div className='text-foreground-default text-base font-medium'>
                                <FormattedMessage
                                    defaultMessage='No cost centers found for your user. Please contact your administrator.'
                                    id='confirm-shop-transaction.no-cost-centers'
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </WizardScreenContainer>
    );
};
